<div class="flex m-right-gap">
    <div class="project-status">
        <span class="status-text">Project Status: <strong class="status-value">{{statusName}}</strong></span>
        <span class="status-indicator" [ngClass]="this.badgeStyle"></span>
    </div>
    <app-button [disabled]="!isSummaryDownloadEnabled" label="Summary" iconPos="right" [outlined]="true" [pTooltip]="downloadSummaryTooltip" tooltipPosition="top"
        severity="secondary" [icon]="isSummaryDownloading ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
        (onClickEvent)="onDownloadSummaryFileClick()">
    </app-button>
</div>